import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';
import { AuthGuard } from '../../guards/auth.guard';
import { FremiumGuard } from '../../guards';

const children = [
  { path: '', component: ProfileEditComponent }
];

export const routes: Routes = [
  { path: 'profile', canActivate: [AuthGuard, FremiumGuard], children },
  { path: 'perfil', canActivate: [AuthGuard, FremiumGuard], children },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {
}
